import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

import EmailSubscribe from 'Components/EmailSubscribe/EmailSubscribe';

const messages = defineMessages({
  button_text: {
    id: 'giveaway-sold-out.button-text',
    defaultMessage: 'Subscribe to email',
  },
  button_text_short: {
    id: 'giveaway-sold-out.button-text-short',
    defaultMessage: 'Subscribe',
  },
});


const GiveawaySoldOut = ({ subscribed, intl }) => {
  const { formatMessage } = intl;
  return (
    <div className="product-giveaway-newsletter-required sold-out">
      <div className="subscribe-area">
        <div className="subscribe-text">
          <FontAwesomeIcon icon={faTriangleExclamation} />
          <FormattedMessage id="giveaway-sold-out.subscribe" defaultMessage="SOLD OUT" />
        </div>
        {!subscribed &&
          <React.Fragment>
            <div className="sold-out-text">
              <FormattedMessage
                id="giveaway-sold-out.not-subscribed.sold-out-text"
                defaultMessage="Sorry, you've missed out this time. Subscribe to our Email Newsletter to hear about future offers and promotions."
              />
            </div>
            <EmailSubscribe
              singleOptIn
              context={'Sold Out Giveaway'}
              buttonText={formatMessage(messages.button_text)}
              buttonTextShort={formatMessage(messages.button_text_short)}
            />
          </React.Fragment>
        }
        {subscribed &&
          <div className="sold-out-text">
            <FormattedMessage
              id="giveaway-sold-out.subscribed.sold-out-text"
              defaultMessage="Sorry, you've missed out this time. Stay tuned for future offers and promotions."
            />
          </div>
        }
      </div>
      {!subscribed &&
        <div className="subscribe-smallprint">
          <FormattedMessage
            id="giveaway-sold-out.small-print"
            defaultMessage="You can unsubscribe via the newsletter at any time. By subscribing to our newsletter you agree to our {privacyPolicyLink}."
            values={{
              privacyPolicyLink: <a href={'https://www.fandom.com/privacy-policy'} target="_blank" rel="noopener noreferrer">
                <FormattedMessage id="giveaway-sold-out.small-print.privacy-policy" defaultMessage="Privacy Policy" />
              </a>,
            }}
          />
        </div>
      }
    </div>
  );
};

GiveawaySoldOut.propTypes = {
  subscribed: PropTypes.bool,
};

GiveawaySoldOut.defaultProps = {
  subscribed: false,
};

export default injectIntl(GiveawaySoldOut);
